import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ProductOrder, Company, OnlineOrder } from '../../../shared/models';
import { CartService } from '../../../shared/services/cart.service';

import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false
})
export class CartComponent implements OnInit {
  @Input() isCheckout: boolean = false;
  @Input() orderNumber: number;
  @Input() order: OnlineOrder;
  
	items: ProductOrder[] = [];

  total: number;
  prettyTotal: string;
  serverUrl: string = environment.server_url;

  constructor(private cartServ: CartService,
    private router: Router,
    private route: ActivatedRoute) { }

  reload() {
  	this.ngOnInit();
  }

  ngOnInit(): void {
    if(this.orderNumber) {
      this.cartServ.setUseStorage(false);
      this.cartServ.setItems(this.order.product_orders);
      this._fetchData();
    } else {
      this._fetchData();
    }
  }

  removeItem(item: ProductOrder) {
    this.cartServ.removeItem(item);
    this._fetchData();
  }

  customerInfo() {
    let company: Company = JSON.parse(localStorage.getItem('current_company'));
    setTimeout(() => {
      Company.setAdditionalData(company);
      if(company.deliveryStatus == 'closed') {
        if(confirm("O delivery está encerrado atualmente. Caso queira TENTAR contato com o estabelecimento mesmo assim, clique em OK.")) {
          let encodedMsg = encodeURIComponent("Olá! Estou tentando fazer um pedido, mas o estabelecimento aparece como 'fechado'. Há alguma previsão de retorno?");
          window.open(`https://wa.me/55${company.whatsapp_number}?text=${encodedMsg}`, "_blank");
        }
      } else {
        this.router.navigate(['../dados-cliente'], {relativeTo: this.route});
      }
    }, 100);
  }
  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  changeQuantity(item: ProductOrder, event: {value: number, updated: boolean}) {
    if(event.value == 0) {
      this.removeItem(item);
      return;
    }
    if(event.updated) {
      item.quantity = event.value;
      this.cartServ.changeQuantity(item);
      ProductOrder.setAdditionalData(item);
      this._recalculate();
    }
  }

  changeNotes(item: ProductOrder) {
    for(let i = 0; i < item.notes_obj.length; i++) {
      let note = item.notes_obj[i];
      if(note.text.length == 0) {
        item.notes_obj.splice(i, 1);
      }
    }
    this.cartServ.setItems(this.items);
  }

  scrollDown(event) {
    event.preventDefault();
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  }

  private _recalculate() {
    this.total = this.cartServ.getTotal();
    this.prettyTotal = this.cartServ.getPrettyTotal();
  }

  private _fetchData() {
    this.items = this.cartServ.getItems();

    for(let item of this.items) {
      ProductOrder.setAdditionalData(item);
    }

    this._recalculate();
  }

}
